import {
  DEFAULT_VEHICLE_MIN_RENTAL_DAYS,
  enforceMinVehicleRentalRange,
  getMinRentalEndDateForDays,
} from "@/lib/calendar/vehicle-min-rental";

/** Durée minimum de location pour la recherche globale (barre d'accueil) */
export const MIN_SEARCH_RENTAL_DAYS = DEFAULT_VEHICLE_MIN_RENTAL_DAYS;

/** Fin de plage minimale : start + 3 nuits (ex. 16 mai → 19 mai = 3 jours) */
export const getMinRentalEndDate = (start: Date): Date =>
  getMinRentalEndDateForDays(start, MIN_SEARCH_RENTAL_DAYS);

/**
 * Garantit une plage d'au moins MIN_SEARCH_RENTAL_DAYS jours de location.
 * Si la fin choisie est trop proche, elle est étendue automatiquement.
 */
export const enforceMinSearchRentalRange = (
  from: Date,
  to: Date,
  maxSelectableDate: Date
): DateRange =>
  enforceMinVehicleRentalRange(
    from,
    to,
    MIN_SEARCH_RENTAL_DAYS,
    maxSelectableDate
  );
